<template>
    <nav class="mainNav">
        <ul>
            <li >
                <router-link to="/">{{ $t('nav.works') }}</router-link>
            </li>
            <li>
                <router-link to="/about">{{ $t('nav.about') }}</router-link>
            </li>
        </ul>
    </nav>
</template>

<script>
export default {
    name: 'MainNav',
    data () {
        return {

        }
    }
}
</script>

<style lang="scss">
    @import './mainNav';
</style>



// WEBPACK FOOTER //
// src/components/MainNav/MainNav.vue